import { useEffect, useRef, useState } from "react";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import API_URL from "../../constant/api.config";
import { connect } from "react-redux";
import { hideLoading, showLoading } from "../../actions/loaderAction";
import { deleteInquiry, getAllAdminInquiries } from "../../actions/inquiryAction";
import ReactPaginate from "react-paginate";
import SupplierInquiriesFilter from "./SupplierInquiriesFilter";
import SubHeader from "../../components/SubHeader";
import Emitter from "../../utils/Emitter";
import MediumPopup from "../../components/MediumPopup";
import CheckBox from "../../components/CheckBox";
import Select from "react-select";
import { getCountryList } from "../../actions/defaultDataAction";
import { useAuth } from "../../AuthProvider";
import {
  setAuthHeaders,
  showErrorMessage,
  showSuccessMessage,
  convertUTCToTzDate,
  buildPath
} from "../../utils/common";
import axiosHttp from "../../axiosHttp";
import ButtonAdminpanel from "../../components/ButtonAdminpanel";
import ButtonCancell from "../../components/ButtonCancell";
import errorMessages from "../../constant/errorMessages";
import { cloneDeep, filter, isEmpty, join, map, size, trim } from "lodash";
import NoDataFound from "../../components/common/NoDataFound";
import ToolipsCustom from "../../components/ToolipsCustom";
import { Link, useParams } from 'react-router-dom';
import SupplierInquiry from "../../components/inquiry/SupplierInquiry";
import roles from "@/constant/roles.config";
import { privateRoutePaths } from "@/routes/private.route.config";
import SmallPopup from "@/components/SmallPopup";
import defaultValues from '@/constant/defaultValues';
import InputField from "@/components/InputField";
import { getCategories } from "@/actions/defaultDataAction";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  ClassicEditor,
  Essentials,
  Bold,
  Italic,
  Underline,
  FontSize,
  Paragraph,
  List,
} from "ckeditor5";
import InquiryList from "@/modules/frontend/components/Inquiry/InquiryList";
import regExpressions from '../../constant/regExpressions';
import DropDown from "@/components/DropDown";

const isOtherLabel = (label) =>
  /^others?$/i.test(String(label || "").trim());

const SupplierInquiries = (props) => {
  const { user, isSuperAdmin, isDemoUser, isViewer, isPreKYCUser, isEndUser, isInqUser, isAdmin } = useAuth();
  
  const invalidEmails = defaultValues.IGNORE_EMAILS;
  const { EMAIL_FIELD_MAX_LENGTH } = defaultValues;

  const { fordate } = useParams();
  const [cKey, setCkey] = useState(0);
  const [fdate, setFdate] = useState(null);

  const [allInquiries, setAllInquiries] = useState([]);
  const [pagination, setPagination] = useState([]);
  const [limit, setLimit] = useState(8);
  const [current_page, setCurrentPage] = useState(1);
  const [searchFilterObj, setSearchFilterObj] = useState({
    filter_val: null,
    findWhom: "All",
    inq_type: "All",
    selected_country: null,
    startDate: null,
    endDate: null
  });

  const initialState = {
    inq_id:"",
    company_name: "",
    contact_person: "",
    email: "",
    phone: "",
    industry: "",
    country: "",
    product: "",
    quantity: "",
    unit: "",
    message: "",
    type: "Supplier"};

  const [tableKey, setTableKey] = useState(0);

  const [mediummodalShow, setMediumModalShow] = useState(false);
  const [smallmodalShow, setSmallModalShow] = useState(false);
  const [selectedInquiry, setSelectedInquiry] = useState(null);

  const [countryList, setCountryList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const headers = setAuthHeaders();

  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [isButtonDisabled, setisButtonDisabled] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [inqModalShow, setInqModalShow] = useState(false);
  const [inqType, setInqType] = useState("SUPPLIER");
  const [memberOptLoader, setMemberOptLoader] = useState(false);

  const [phoneValue, setphoneValue] = useState("");

  const [deleteInqId, setDeleteInqId] = useState();

  const { IMAGE_PATH } = defaultValues;
  const industryList = defaultValues.INDUSTRIES_LIST;
  const [selectedIndustry, setSelectedIndustry] = useState(null);


    const [rawCategories, setRawCategories] = useState([]);
  
    const [selectIndustry,setSelectIndustry] = useState("");
  

  const [popupType,setPopupType] = useState("");

    const isOtherSelected = isOtherLabel(selectedIndustry?.label);

  // Other ho to textbox value, warna dropdown label
  const getFinalIndustry = () =>
    isOtherSelected ? selectIndustry.trim() : (selectedIndustry?.label || "");


   const isCustomOtherIndustry = (inq) => {
    if (!inq?.industry) return false;

    const name = String(inq.industry).trim().toLowerCase();
    if (isOtherLabel(name)) return false;

    // categories abhi load nahi hui to ind_data par fallback
    if (isEmpty(rawCategories)) return !!inq.ind_data;

    const existsInList = rawCategories.some(
      (c) => String(c.label).trim().toLowerCase() === name
    );
    return !existsInList;
  };

 
  const getPrefix = () => {
    if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
    if (user && isDemoUser) return roles.DEMO.prefix;
    if (user && isEndUser) return roles.END_USER.prefix;
    if (user && isViewer) return roles.VIEWER.prefix;
    return roles.SUPER_ADMIN.prefix;
  };

  const getAllInquiries = async (limit, current_page, filterObj) => {
    await props.showLoading();
    await props
      .getAllInquiries(limit, current_page, filterObj)
      .then((response) => {
        setAllInquiries(response.data);
        setPagination(response.pagination);
      })
      .catch((err) => {
        console.log("Error ==== ", err);
        showErrorMessage("Something Went Wrong!!");
      });
    await props.hideLoading();
  };

  const [itemOffset, setItemOffset] = useState(0);

  const endOffset = itemOffset + limit;
  // const currentItems = allInquiries.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(pagination.total / limit);

  const handlePageClick = (event) => {
    getAllInquiries(limit, event.selected + 1, searchFilterObj);
    // const newOffset = (event.selected * limit) % allInquiries.length;
    // setItemOffset(newOffset);
  };

  const setInquiriesFilters = (newState) => {
    props.showLoading();
    newState.table_search = "";
    newState.current_page = 1;
    setCurrentPage(1);
  };

  const filterApplyOnInquiries = (filterObj) => {
    setSearchFilterObj(filterObj);
    getAllInquiries(limit, current_page, filterObj);
    setTableKey((prev) => prev + 1);
    props.hideLoading();
  };


  const handlePopupShow = (menuType, inquiry) => {

    console.log("RTTYY",inquiry);
    setPopupType(menuType);
    setSelectedInquiry(inquiry);

   const isOtherInquiry = isCustomOtherIndustry(inquiry);

    const otherCategory = rawCategories.find((c) => isOtherLabel(c.rawLabel));
  const countryMatch = countryList?.find(
        (country) => String(country.label) === String(inquiry?.country)
      );

      const matchedCategory = isOtherInquiry
      ? otherCategory
      : rawCategories.find(
          (c) =>
            String(c.label).trim().toLowerCase() ===
            String(inquiry?.industry || "").trim().toLowerCase()
        );

    // Other ho to saved text textbox me, warna khali
    setSelectIndustry(isOtherInquiry ? (inquiry.industry || "") : "");

    setSelectedIndustry(
      matchedCategory
        ? { value: matchedCategory.value, label: matchedCategory.label }
        : null
    );
      setSelectedCountry(countryMatch || null);
   
    setFormData({
      ...initialState,
      inq_id:inquiry.id,
      company_name: inquiry.company_name || "",
      contact_person: inquiry.contact_person || "",
      email: menuType === "edit" ? inquiry.email || "" : "",
      phone: inquiry.phone || "",
      industry: isOtherInquiry
        ? inquiry.industry
        : (matchedCategory ? matchedCategory.label : ""),
      country: countryMatch ? countryMatch.label : "",
      product: inquiry.product || "",
      quantity: inquiry.quantity || "",
      unit: inquiry.unit || "",
      message: inquiry.message || "",
    });

    setphoneValue(inquiry.phone || "");
    setErrors({});
    setisButtonDisabled(false);
    setMediumModalShow(true);
  };

  

  const handleCountryChange = async (cval) => {
    setSelectedCountry(cval);
     setFormData((prevalue) => {
      return {
        ...prevalue,
        country: cval.label,
      };
    });
   };

  



  const fetchCountries = async () => {
    await props
      .getCountryList()
      .then((data) => {
        const options = data.map((country) => ({
          value: country.id,
          label: country.name,
          countryCode: country.iso2,
        }));
        setCountryList(options);
      })
      .catch((err) => {
        console.log("Error >>>> ", err);
      });
  };

  


  const handleCancelClick = (e) => {
    e.preventDefault();
    setMediumModalShow(false);
  };

  const handleChange = (e) => {
    setFormData((prevalue) => {
      return {
        ...prevalue,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleFocusOut = async (e) => {

    let flag = 0;
    let er = { ...errors };

    if (e.target.name === 'company_name') {
      if (e.target.value === "") {
        flag = 1;
        er.company_name = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > 150) {
        flag = 1;
        er.company_name = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else {
        const regExp = regExpressions.company_name;
        const check = regExp.test(e.target.value);
        if (check === false) {
          flag = 1;
          er.company_name = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          flag = 0;
          er.company_name = "";
        }
      }
    }


    if (e.target.name === 'contact_person') {
      if (e.target.value === "") {
        flag = 1;
        er.contact_person = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > 50) {
        flag = 1;
        er.contact_person = errorMessages.MAX_LENGTH_50_EXCEEDED;
      } else {
        const regExp = regExpressions.name;
        const check = regExp.test(e.target.value);
        if (check === false) {
          flag = 1;
          er.contact_person = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          flag = 0;
          er.contact_person = "";
        }
      }
    }

    if (e.target.name === 'email') { 
      if (e.target.value === "") {
        flag = 1;
        er.email = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > EMAIL_FIELD_MAX_LENGTH) {
        flag = 1;
        er.email = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else {
        const currentEmail = e.target.value.split("@")[1];
        const regExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const check = regExp.test(e.target.value);
        if (check === false) {
          flag = 1;
          er.email = errorMessages.IN_VALID_FIELD_FORMAT;
        } else if (invalidEmails.includes(currentEmail)) {
          flag = 1;
          er.email = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          flag = 0;
          er.email = "";
        }
      }
    }


    if (e.target.name === "phone") {
      let phoneValue = e.target.value.trim();
      let numberWithoutCountryCode = phoneValue.replace(/^\+(\d{1,4})\s?/, "").replace(/\s/g, "");
      if (numberWithoutCountryCode === '+') {
        flag = 0;
        er.phone = "";
      }
      if (phoneValue !== '' && phoneValue.length > 4 && numberWithoutCountryCode > 0) {
        if (!isValidPhoneNumber(phoneValue)) {
          flag = 1;
          er.phone = errorMessages.CONTACT_NUMBER_VALIDATION_MSG;
        } else {
          flag = 0;
          er.phone = "";
        }
      }
    }

    if (e.target.name === 'industry') {
      if (e.target.value === '') {
        flag = 1;
        er.industry = errorMessages.FIELD_REQUIRED;
      } else {
        flag = 0;
        er.industry = "";
      }
    }

    if (e.target.name === 'other_industry') {
      if (e.target.value === '') {
        flag = 1;
        er.other_industry = errorMessages.FIELD_REQUIRED;
      } else {
        flag = 0;
        er.other_industry = "";
      }
    }

    if (e.target.name === 'country') {
      if (e.target.value === '') {
        flag = 1;
        er.country = errorMessages.FIELD_REQUIRED;
      } else {
        flag = 0;
        er.country = "";
      }
    }

    if (e.target.name === 'product') {
      if (e.target.value === "") {
        flag = 1;
        er.product = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > 255) {
        flag = 1;
        er.product = errorMessages.MAX_LENGTH_255_EXCEEDED;
      } 
      else {
        flag = 0;
        er.product = "";
      }

    }

    if (e.target.name === 'quantity') {
      let quantity = e.target.value;
      let quantityReg = /^(?!0(\.0+)?$)(\d+(\.\d+)?|\.\d+)$/
      if (e.target.value !== '' && quantity.length > 0) {
        if (quantity.length > 20) {
          flag = 1;
          er.quantity = errorMessages.MAX_LENGTH_20_EXCEEDED;
        } else {
          const check = quantityReg.test(e.target.value);
          if (check === false) {
            flag = 1;
            er.quantity = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            flag = 0;
            er.quantity = '';
          }
        }
      }
    }

    if (e.target.name === 'unit') {
      let unit = e.target.value;
      let untiEpr = /^[a-zA-Z]+(\s*[-&]?\s*[a-zA-Z]+)*(\s*\(\s*[a-zA-Z]+\s*\))?$/
      if (e.target.value !== '' && unit.length > 0) {
        if (unit.length > 20) {
          flag = 1;
          er.unit = errorMessages.MAX_LENGTH_20_EXCEEDED;
        } else {
          const check = untiEpr.test(e.target.value);
          if (check === false) {
            flag = 1;
            er.unit = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            flag = 0;
            er.unit = '';
          }
        }
      }
    }

    setErrors(er);
    if (flag === 0) {
      setisButtonDisabled(false);
      return false;
    } else {
      return true;
    }
  };

   const handlePhoneChange = (val) => {
    setphoneValue(val);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        phone: val,
      };
    });
  };

  //   const handleIndustryChange = (cval) => {
  //   setSelectedIndustry(cval);
  //    setSelectIndustry("");
  //    setErrors((prev) => ({ ...prev, industry: "" }));
  //   setFormData((prevalue) => {
  //     return {
  //       ...prevalue,
  //       industry: cval.label,
  //     };
  //   });

  // };
    const handleIndustryChange = (cval) => {
    const isOther = isOtherLabel(cval.label);

    // Other se kisi aur option par jao to textbox clear
    if (!isOther) setSelectIndustry("");

    setSelectedIndustry(cval);
    setErrors((prev) => ({ ...prev, industry: "" }));
    setFormData((prev) => ({
      ...prev,
      industry: isOther ? selectIndustry : cval.label,
    }));
  };

    const handleOtherTextChange = (e) => {
    const val = e.target.value;
    setSelectIndustry(val);
    setErrors((prev) => ({ ...prev, industry: "" }));
    setFormData((prev) => ({ ...prev, industry: val }));
  };


  const validation = () => {
      console.log("formData industry",formData.industry);
      let er = { ...errors };
      let isValid = true;
  
      if (!formData.company_name || formData.company_name === "") {
        isValid = false;
        er.company_name = errorMessages.FIELD_REQUIRED;
      } else if (formData.company_name.length > 150) {
        isValid = false;
        er.company_name = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else {
        const regExp = regExpressions.company_name;
        const check = regExp.test(formData.company_name);
        if (check === false) {
          isValid = false;
          er.company_name = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          er.company_name = "";
        }
      }
  
  
      if (formData.contact_person === "") {
        isValid = false;
        er.contact_person = errorMessages.FIELD_REQUIRED;
      } else if (formData.contact_person.length > 50) {
        isValid = false;
        er.contact_person = errorMessages.MAX_LENGTH_50_EXCEEDED;
      } else {
        const regExp = regExpressions.name;
        const check = regExp.test(formData.contact_person);
        if (check === false) {
          isValid = false;
          er.contact_person = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          er.contact_person = "";
        }
      }
  
      if (formData.email === "") {
        isValid = false;
        er.email = errorMessages.FIELD_REQUIRED;
      } else if (formData.email.length > EMAIL_FIELD_MAX_LENGTH) {
        isValid = false;
        er.email = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else {
        const currentEmail = formData.email.split("@")[1];
        const regExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const check = regExp.test(formData.email);
        if (check === false) {
          isValid = false;
          er.email = errorMessages.IN_VALID_FIELD_FORMAT;
        } else if (invalidEmails.includes(currentEmail)) {
          isValid = false;
          er.email = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          er.email = "";
        }
      }


  
  
      if (phoneValue) {
        let numberWithoutCountryCode = phoneValue.replace(/^\+(\d{1,4})\s?/, '');
        numberWithoutCountryCode = numberWithoutCountryCode.replace(/\s/g, '');
        if (!phoneValue || !isValidPhoneNumber(phoneValue) && numberWithoutCountryCode.length > 0) {
          isValid = false;
          er.phone = errorMessages.CONTACT_NUMBER_VALIDATION_MSG;
        }
      }
  
  
      // if (formData.industry === '') {
      //   isValid = false;
      //   er.industry = errorMessages.FIELD_REQUIRED;
      // } else {
      //   er.industry = "";
      // }
         const finalIndustry = getFinalIndustry();
        if (!selectedIndustry) {
          isValid = false;
          er.industry = errorMessages.FIELD_REQUIRED;
        } else if (isOtherSelected && !finalIndustry) {
          isValid = false;
          er.industry = "Please enter other industry";
        } else if (
          isOtherSelected &&
          rawCategories.some(
            (c) =>
              !isOtherLabel(c.label) &&
              String(c.label).trim().toLowerCase() === finalIndustry.toLowerCase()
          )
        ) {
          isValid = false;
          er.industry = "This industry is already in the list. Please select it from the dropdown.";
        } else {
          er.industry = "";
        }
  
      if (formData.country === '') {
        isValid = false;
        er.country = errorMessages.FIELD_REQUIRED;
      } else {
        er.country = "";
      }
  
  
      if (formData.product === "") {
        isValid = false;
        er.product = errorMessages.FIELD_REQUIRED;
      } else if (formData.product.length > 255) {
        isValid = false;
        er.product = errorMessages.MAX_LENGTH_255_EXCEEDED;
      } else {
        er.product = "";
      }
  
  
  
      let quantity = formData.quantity;
      let quantityReg = /^(?!0(\.0+)?$)(\d+(\.\d+)?|\.\d+)$/;
      if (quantity !== '' && quantity.length > 0) {
        if (quantity.length > 20) {
          isValid = false;
          er.quantity = errorMessages.MAX_LENGTH_20_EXCEEDED;
        } else {
          const check = quantityReg.test(quantity);
          if (check === false) {
            isValid = false;
            er.quantity = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er.quantity = '';
          }
        }
      }
  
      let unit = formData.unit;
      let untiEpr = /^[a-zA-Z]+(\s*[-&]?\s*[a-zA-Z]+)*(\s*\(\s*[a-zA-Z]+\s*\))?$/;
      if (unit !== '' && unit.length > 0) {
        if (unit.length > 20) {
          isValid = false;
          er.unit = errorMessages.MAX_LENGTH_20_EXCEEDED;
        } else {
  
          const check = untiEpr.test(unit);
          if (check === false) {
            isValid = false;
            er.unit = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er.unit = '';
          }
        }
  
      }


      setErrors(er);
  
      if (!isValid) {
        return false;
      }
  
      return true;
    };

    


  const handleInquirySubmit = async (e) => {
  e.preventDefault();
  if (!validation()) return;

  const headers = setAuthHeaders();
  props.showLoading();
  setisButtonDisabled(true);

   const payload = {
      ...formData,
      industry: getFinalIndustry(),
      industry_id: selectedIndustry?.value, // category id (backend ko chahiye ho to)
      is_other: isOtherSelected,            // custom text hai ya nahi
    };

  try {
    const response = await axiosHttp.post(
      `${API_URL}/supplier-post-inquiry/${popupType}`,
      payload,
      { headers, timeout: 10000 }
    );

    if (response.status === 200 && response.data.status === true) {
      setMediumModalShow(false);
      const msg = popupType === "edit" ? "Update" : "Clone";
      showSuccessMessage(`${msg} Inquiry  Successfully!`);

      const pageToLoad = current_page || 1;
      setCurrentPage(pageToLoad);
      await getAllInquiries(limit, pageToLoad, searchFilterObj);
      setTableKey((prev) => prev + 1); // resets paginator to the right page

      setFormData(initialState);
      setErrors({});
      setphoneValue("");
      setSelectedIndustry(null);
      setSelectedCountry(null);
    } else {
      const apiErrors = response.data.error || {};
      const errs = {};
      ["company_name", "contact_person", "email", "country", "industry", "product", "unit"]
        .forEach((f) => { if (apiErrors[f]) errs[f] = apiErrors[f][0]; });
      if (apiErrors.quantity) errs.quantity = apiErrors.quantity[0];
      setErrors(errs);
    }
  } catch (err) {
    console.log("Error =============", err);
    showErrorMessage("Something Went Wrong!");
  } finally {
    props.hideLoading();
    setisButtonDisabled(false);
  }
};

  const styleError = {
    display: "block",
  };



  const handleInquiryClick = () => {
    setInqType("SUPPLIER");
    setInqModalShow(true);
  }



  const handleDeleteInquiry = async (inq) => {

    if (inq) {
      let inqId = inq.id;
      setDeleteInqId(inqId);
      setSmallModalShow(true);
    
    }
  }

  const handleConfirmDeleteClick = () => {
    props
      .deleteInquiry(deleteInqId)
      .then((response) => {
        if (response.status === true) {
          showSuccessMessage("Inquiry Deleted Successfully!");
          setCurrentPage(1);
          setLimit(8);
          getAllInquiries(limit, 1, searchFilterObj);
          setTableKey((prev) => prev + 1);
        }
        setSmallModalShow(false);
      })
      .catch((err) => {
        console.log("Error == ", err);
        showErrorMessage("Something Went Wrong!!");
      });
  };


  useEffect(() => {
    Emitter.on("FILTER_INQUIRIES", filterApplyOnInquiries);
    Emitter.on("SET_FILTER_INQUIRIES", setInquiriesFilters);
    return () => {
      Emitter.off("FILTER_INQUIRIES", filterApplyOnInquiries);
    };
  }, []);

  useEffect(() => {
    fetchCountries();
  }, []);


   const categoryList = rawCategories;

  const selectedCategoryOption = (() => {
    const cat = selectedIndustry;
    if (cat === undefined || cat === null || cat === "") return null;
    const key = typeof cat === "object" ? (cat.value ?? cat.id) : cat;
    return rawCategories.find((o) => String(o.value) === String(key)) || null;
  })();

  // "Other (Abc)" sirf selected value par dikhao, dropdown menu me nahi
  const formatCategoryLabel = (option, { context } = {}) => {
    if (context === "value" && isOtherLabel(option.rawLabel || option.label) && selectIndustry) {
      return `Other (${selectIndustry})`;
    }
    return option.label;
  };

  useEffect(() => {
    const fetchDictionaries = async () => {
      await props.getCategories().then((response) => {
        if (!isEmpty(response)) {
          setRawCategories(
            map(response, (v) => ({
              label: v.category_name,
              rawLabel: v.category_name,
              value: v.id,
            }))
          );
        }
      });
    };

    fetchDictionaries();
  }, []);





  return (
    
        <div className="data-table-main" key={cKey}>
        <SubHeader
            layer1="Supplier Inquiries"
            layer2=""
            layer3="List"
            pageName="Supplier Inquiries"
            clickable={{
            layer1: "",
            layer2: "",
            layer3: "",
            }}
        />

      <div className="send-receive-inquiry">


        <SupplierInquiriesFilter handleClick={handleInquiryClick} fordate={props && props.fordate} pageName="SUPPLIER_INQUIRIES" />

        <div className="p-0 border bg-white rounded card-shadow mt-3 send-receive-table">
          {/* <h5 className="table-text p-3">Inquiry Lists</h5> */}
          <div className="table-wrape">
            <table className="simple-table list-table" width="100%">
              <thead>
                <tr>
                  <th className="id">Inquiry Id</th>
                  <th className="name">Company Name</th>
                  <th className="category">Category</th>
                  <th className="contact-info">Contact Info</th>
                  <th className="assign_id">Assign to</th>
                  <th className="contact-info">Type</th>
                  <th className="created-at">Created At</th>
                  <th className="action">Action</th>
                </tr>
              </thead>
              <tbody>
                {allInquiries && allInquiries.map((inquiry) => (
                  <tr>
                    <td> 
                      {isSuperAdmin ? (
                          <Link to={`/${getPrefix(user)}${buildPath(privateRoutePaths.VIEW_SUPPLIERS, { id: inquiry.id })}`}>
                              
                                  {inquiry.inquiry_unique_id}
                              
                          </Link>
                          ) : (
                            inquiry.inquiry_unique_id
                          )
                        } 
                      </td>
                       
                    <td>
                      <h4>{inquiry.company_name}</h4>
                      <div className="d-flex justify-content-between">
                        <p className="text-muted">
                          <svg
                            version="1.1"
                            id="fi_747340"
                            x="0px"
                            y="0px"
                            viewBox="0 0 512 512"
                            height={"18px"}
                            width={"18px"}
                            fill="#585858"
                          >
                            <g>
                              <g>
                                <path
                                  d="M256,110.062c-52.412,0-95.053,42.641-95.053,95.053s42.641,95.053,95.053,95.053s95.053-42.641,95.053-95.053
                                    S308.413,110.062,256,110.062z M256,260.146c-30.344,0-55.031-24.687-55.031-55.031s24.687-55.031,55.031-55.031
                                    s55.031,24.687,55.031,55.031S286.344,260.146,256,260.146z"
                                ></path>
                              </g>
                            </g>
                            <g>
                              <g>
                                <path
                                  d="M256,0C142.899,0,50.885,92.015,50.885,205.115v5.67c0,57.2,32.794,123.856,97.474,198.113
                                    c46.888,53.832,93.121,91.368,95.065,92.94L256,512l12.576-10.161c1.945-1.572,48.178-39.108,95.065-92.94
                                    c64.679-74.258,97.474-140.913,97.474-198.113v-5.67C461.115,92.015,369.101,0,256,0z M421.093,210.786
                                    c0,96.665-124.551,213.68-165.093,249.202C215.447,424.455,90.907,307.444,90.907,210.786v-5.67
                                    c0-91.032,74.061-165.093,165.093-165.093s165.093,74.061,165.093,165.093V210.786z"
                                ></path>
                              </g>
                            </g>
                          </svg>
                          <span className="mx-1">
                            {inquiry.type == "Supplier"
                              ? inquiry.country
                              : inquiry.country_to}
                          </span>
                        </p>
                      </div>
                    </td>
                    <td>
                      <p>
                        {/* {inquiry.ind_data || selectedCategoryOption?.value === "Other" ? 'Other - ' + inquiry.industry : inquiry.industry} */}
                         {isCustomOtherIndustry(inquiry) ? 'Other - ' + inquiry.industry : inquiry.industry}
                      </p>
                    </td>
                     <td>
                      <div className="">
                        <p className="d-flex align-items-center gap-2 mt-1">
                          <svg
                            version="1.1"
                            id="fi_266134"
                            x="0px"
                            y="0px"
                            viewBox="0 0 512 512"
                            height={"18px"}
                            width={"18px"}
                            fill="#585858"
                          >
                            <g>
                              <g>
                                <path
                                  d="M333.187,237.405c32.761-23.893,54.095-62.561,54.095-106.123C387.282,58.893,328.389,0,256,0
                                S124.718,58.893,124.718,131.282c0,43.562,21.333,82.23,54.095,106.123C97.373,268.57,39.385,347.531,39.385,439.795
                                c0,39.814,32.391,72.205,72.205,72.205H400.41c39.814,0,72.205-32.391,72.205-72.205
                                C472.615,347.531,414.627,268.57,333.187,237.405z M164.103,131.282c0-50.672,41.225-91.897,91.897-91.897
                                s91.897,41.225,91.897,91.897S306.672,223.18,256,223.18S164.103,181.954,164.103,131.282z M400.41,472.615H111.59
                                c-18.097,0-32.82-14.723-32.82-32.821c0-97.726,79.504-177.231,177.231-177.231s177.231,79.504,177.231,177.231
                                C433.231,457.892,418.508,472.615,400.41,472.615z"
                                ></path>
                              </g>
                            </g>
                          </svg>
                           {inquiry.contact_person}
                        </p>
                        <p className="d-flex align-items-center gap-2 mt-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            id="fi_2907765"
                            data-name="Layer 1"
                            viewBox="0 0 24 24"
                            width="18"
                            height="18"
                            fill="#585858"
                          >
                            <path d="M20,19.75H4A2.76,2.76,0,0,1,1.25,17V7A2.76,2.76,0,0,1,4,4.25H20A2.76,2.76,0,0,1,22.75,7V17A2.76,2.76,0,0,1,20,19.75ZM4,5.75A1.25,1.25,0,0,0,2.75,7V17A1.25,1.25,0,0,0,4,18.25H20A1.25,1.25,0,0,0,21.25,17V7A1.25,1.25,0,0,0,20,5.75Z"></path>
                            <path d="M12,13.35a3.25,3.25,0,0,1-1.65-.45L1.62,7.71a.76.76,0,0,1-.27-1,.74.74,0,0,1,1-.26l8.74,5.18a1.69,1.69,0,0,0,1.76,0l8.74-5.18a.74.74,0,0,1,1,.26.76.76,0,0,1-.27,1L13.65,12.9A3.25,3.25,0,0,1,12,13.35Z"></path>
                          </svg>
                           {inquiry.email}
                          
                        </p>
                        <p className="d-flex align-items-center gap-2 my-1">
                          <svg
                            height="18"
                            viewBox="-106 0 469 469.33333"
                            width="18"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="#585858"
                            id="fi_1551230"
                          >
                            <path d="m206.246094 0h-156.160156c-27.558594.03125-49.890626 22.363281-49.917969 49.921875v369.492187c.027343 27.558594 22.359375 49.890626 49.917969 49.917969h156.160156c27.558594-.027343 49.890625-22.359375 49.921875-49.917969v-369.492187c-.03125-27.558594-22.363281-49.890625-49.921875-49.921875zm28.585937 419.414062c-.015625 15.78125-12.804687 28.570313-28.585937 28.585938h-156.160156c-15.78125-.015625-28.570313-12.804688-28.585938-28.585938v-369.492187c.015625-15.785156 12.804688-28.574219 28.585938-28.589844h156.160156c15.78125.015625 28.570312 12.804688 28.585937 28.589844zm0 0"></path>
                            <path d="m160.167969 42.667969h-64c-5.890625 0-10.667969 4.773437-10.667969 10.664062s4.777344 10.667969 10.667969 10.667969h64c5.890625 0 10.664062-4.777344 10.664062-10.667969s-4.773437-10.664062-10.664062-10.664062zm0 0"></path>
                            <path d="m149.5 405.332031c0 11.785157-9.550781 21.335938-21.332031 21.335938-11.785157 0-21.335938-9.550781-21.335938-21.335938 0-11.78125 9.550781-21.332031 21.335938-21.332031 11.78125 0 21.332031 9.550781 21.332031 21.332031zm0 0"></path>
                          </svg>
                          {inquiry.phone}
                        </p>
                      </div>
                    </td>
                   <td>
                    {(() => {
                      if (!(isSuperAdmin || isAdmin || isInqUser)) {
                        return "-";
                      }

                      const names = inquiry.assign_to_names;
                      const companyName = inquiry.assign_to_raw_company_names?.[0] ?? "-";
                      const isAssigned = !isEmpty(names);
                      const rawCount = Number(inquiry.assign_raw_count) || 0;
                      const hasRaw = rawCount > 0;

                      // Neither assigned nor raw data
                      if (!isAssigned && !hasRaw) {
                        return (
                          <div className="py-2 inquiry-assign">
                            <span className="badge bg-danger">Not Assigned</span>
                          </div>
                        );
                      }

                      // Raw data only: company name + raw count
                      if (!isAssigned && hasRaw) {
                        return (
                          <div className="py-2 inquiry-assign">{`${companyName} - ${rawCount}`}</div>
                        );
                      }

                      // Assigned (with or without raw data): first name + total count
                      const total = size(names) + rawCount;
                      const assignLabel = total === 1 ? names[0] : `${names[0]} - ${total}`;

                      return <div className="py-2 inquiry-assign">{assignLabel}</div>;
                    })()}
                  </td>
                   
                    <td>
                      <p>
                         {inquiry?.created_user_type}
                        

                      </p>
                    </td>
                    <td>
                        {inquiry.created_at && (() => {
                          
                          const createdAt = convertUTCToTzDate(
                            inquiry.created_at,
                            "Etc/UTC",
                            "YYYY-MM-DD hh:mm A"
                          );

                          return (
                            <>
                              {createdAt}
                              <ToolipsCustom subtitle="Universal Time Coordinated" title="UTC" />
                            </>
                          );
                        })()}
                      </td>
                   
                    <td>
                      {/* <div className="d-flex gap-2">
                        
                        {
                          (isSuperAdmin || isViewer || isInqUser) &&
                              
                              <Link to={`/${getPrefix()}${buildPath(privateRoutePaths.VIEW_SUPPLIERS,{ id: inquiry.id })}`} className="fa-regular fa-eye icon-eyes border-0 panle-icon" title="View">
                                 
                              </Link>
                          
                        }
                        
                        {
                          (isSuperAdmin || isInqUser) && <div to="" className="fa-solid fa-trash-can icon-trash border-0 " title="Delete" onClick={() => handleDeleteInquiry(inquiry)}></div>
                        }

                      </div> */}

                      <div className="d-flex gap-2">
                        <div className="text-wrap panle-action action-btn">
                            <div className='dropdown'>
                                <p className='dropdown-toggle' data-bs-toggle="dropdown" aria-expanded="false">
                                <i className="fa-solid fa-ellipsis"></i>
                                </p>
                                <ul className='dropdown-menu supplier-inquiries-action-menu'>
                                    {isSuperAdmin && (
                                     <Link to="#" onClick={(e) => { e.preventDefault(); handlePopupShow("clone",inquiry); }}>
                                        <li className='dropdown-item'>
                                            Clone
                                        </li>
                                    </Link>
                                    )}
                                    
                                    {isSuperAdmin &&
                                      !Number(inquiry.assign_raw_count) &&
                                      isEmpty(inquiry.assign_to_names) && (
                                        <Link to="#" onClick={(e) => { e.preventDefault(); handlePopupShow("edit", inquiry); }}>
                                          <li className="dropdown-item">Edit</li>
                                        </Link>
                                    )}

                                     
                                    {isSuperAdmin &&
                                    <Link to={`/${getPrefix(user)}${buildPath(privateRoutePaths.VIEW_SUPPLIERS, { id: inquiry.id })}`}>
                                        <li className='dropdown-item'>
                                            Assign
                                        </li>
                                    </Link>
                                    }

    
                                  
                                    <Link to={`/${getPrefix(user)}${buildPath(privateRoutePaths.SUPPLIER_INQUIRY_REPORT, { id: inquiry.id })}`}>
                                        <li className='dropdown-item'>
                                            Report
                                        </li>
                                    </Link>
                                    {isSuperAdmin && (

                                    <Link to="#" onClick={(e) => { e.preventDefault(); handleDeleteInquiry(inquiry); }}>
                                        <li className='dropdown-item'>
                                            Delete
                                        </li>
                                    </Link>
                                    )}
                                    
                                </ul>
                            </div>
                          </div>
                   
                        </div>
                      
                    </td>
                  </tr>
                ))}

                {isEmpty(allInquiries) && (
                  <tr>
                    <td colSpan={7}>
                      <div className="text-center mt-3 mb-3">Inquiries not found</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

          </div>
        </div>

      

        <div className="d-flex justify-content-between inquiry-pagination mt-3">
          {pagination.total > 0 && (<>
            <p>
              showing <b>{pagination.from}</b> to <b>{pagination.to}</b> of <b>{pagination.total}</b>
            </p>

            <ReactPaginate
              key={tableKey}
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={2}
              marginPagesDisplayed={2}
              pageCount={pageCount}
              previousLabel="<"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active"
              renderOnZeroPageCount={null}
            />
          </>
          )}
        </div>

      </div>

      {/** Inquiry Detail Pop-up Start */}
      <MediumPopup
        // title={`Inquiry Details - ${
        //   selectedInquiry ? selectedInquiry.company_name : ""
        // }`}
      title={popupType === "edit" ? `Edit Inquiry - ${selectedInquiry.inquiry_unique_id}` : "Clone Inquiry"}
        mediummodalShow={mediummodalShow}
        setMediumModalShow={setMediumModalShow}
      // closeButtonLabel="Cancel"
      // okButtonLabel="Submit"
      // onSubmit={handleInquirySubmit}
      >
        <form onSubmit={handleInquirySubmit}>
           <div className="row">

        <div className="col-sm-12 mb-3 inquiry-info-labal popup">
          <h3> Contact Information

          </h3>
        </div>

        <div className="col-sm-6 ">
          <div className="input-group">
            <label className="form-label required">Company Name</label>
            <div className="input-pad">
              <InputField name="company_name"
                className="form-control"
                autoComplete="off"
                placeholder="Enter company name"
                onChange={handleChange}
                value={formData.company_name}
                onBlur={handleFocusOut}
              />

              {errors.company_name && (
                <span
                  className="company-required"
                  style={styleError}
                >
                  {errors.company_name}
                </span>
              )} 
            </div>
          </div>
        </div>
        <div className="col-sm-6 ">
          <div className="input-group">
            <label className="form-label required">Contact Person</label>
            <div className="input-pad">
              <InputField
                type="text"
                name="contact_person"
                value={formData.contact_person}
                className="form-control"
                autoComplete="off"
                placeholder="Enter contact person"
                onChange={handleChange}
                onBlur={handleFocusOut}
              />
               {errors.contact_person && (
                <span
                  className="company-required"
                  style={styleError}
                >
                  {errors.contact_person}
                </span>
              )} 
            </div>
          </div>
        </div>
        <div className="col-sm-6 ">
          <div className="input-group">
            <label className="form-label required">Email</label>
            <div className="input-pad">
              <InputField
                type="text"
                name="email"
                className="form-control"
                value={formData.email}
                autoComplete="off"
                placeholder={"Enter email"}
                onChange={handleChange}
                onBlur={handleFocusOut}
              />
              {errors.email && (
                <span
                  className="company-required"
                  style={styleError}
                >
                  {errors.email}
                </span>
              )} 
            </div>
          </div>
        </div>

        <div className="col-sm-6 ">
          <div className="input-wrape">
            <label className="form-label">
              Phone Number
            </label>
            <div className="input-pad">
              <PhoneInput
                id="contact-form-phone"
                className="form-control inquiry-phone inp-font-size border-dropdown company-representive-border outer_pages_phone_input"
                name="phone"
                international
                limitMaxLength
                placeholder="Enter phone number"
                autoComplete="off"
                value={phoneValue}
                onChange={handlePhoneChange}
                onBlur={handleFocusOut}

              />
              {errors.phone && (
                <span
                  className="company-required"
                  style={styleError}
                >
                  {errors.phone}
                </span>
              )} 
            </div>
          </div>
        </div>

        <div className="col-sm-12 mb-3 inquiry-info-labal popup">
          <h3>Inquiry Information

          </h3>
        </div>

        <div className="col-sm-6 ">
          <div className="input-group">
            <label className="form-label required">Industry</label>
            <div className="input-pad">
              <DropDown
                name="industry"
                options={categoryList}
                value={selectedCategoryOption}
                onChange={handleIndustryChange}
                placeholder="Select industry"
                className="dd-pad"
                noOptionsMessage={() => "No Industry Found"}
                onBlur={handleFocusOut}
                formatOptionLabel={formatCategoryLabel}
              />
              

              {errors.industry && (
                <span
                  className="company-required"
                  style={styleError}
                >
                  {errors.industry}
                </span>
              )} 
            </div>
          </div>
        </div>

        <div className="col-sm-6 ">
          <div className="input-group">
            <label className="form-label required">Other industry</label>
            <div className="input-pad">

              {isOtherSelected && (
                    <InputField
                      type="text"
                      name="other_industry"
                      className="form-control mt-2"
                      autoComplete="off"
                      placeholder="Enter other industry"
                      value={selectIndustry}
                      onChange={handleOtherTextChange}
                      maxLength={100}
                      onBlur={handleFocusOut}
                    />
                  )}

                   {errors.other_industry && (
                <span
                  className="company-required"
                  style={styleError}
                >
                  {errors.other_industry}
                </span>
              )}
                  </div>
        </div>
        
        </div>

        <div className="col-sm-6 ">
          <div className="input-group">
            <label className="form-label required">Country</label>
            <div className="input-pad">
              <Select
                name="country"
                options={countryList}
                value={selectedCountry}
                onChange={handleCountryChange}
                placeholder="Select country"
                className="dd-pad"
                onBlur={handleFocusOut}
                noOptionsMessage={() => "No Country Found"}
              />
               {errors.country && (
                <span
                  className="company-required"
                  style={styleError}
                >
                  {errors.country}
                </span>
              )} 
            </div>
          </div>
        </div>

        <div className="col-sm-6 ">
          <div className="input-group">
            <label className="form-label required">Product</label>
            <div className="input-pad">

              <InputField
                type="text"
                name="product"
                className="form-control"
                value={formData.product}
                autoComplete="off"
                placeholder="Enter product"
                onChange={handleChange}
                onBlur={handleFocusOut}
              />

              {errors.product && (
                <span
                  className="company-required"
                  style={styleError}
                >
                  {errors.product}
                </span>
              )} 
            </div>
          </div>
        </div>

        <div className="col-sm-3 ">
          <div className="input-group">
            <label className="form-label">Quantity</label>
            <div className="input-pad">
              <InputField
                type="text"
                name="quantity"
                value={formData.quantity}
                className="form-control"
                autoComplete="off"
                placeholder="Enter quantity"
                onChange={handleChange}
                onBlur={handleFocusOut}
              />
              {errors.quantity && (
                <span
                  className="company-required"
                  style={styleError}
                >
                  {errors.quantity}
                </span>
              )} 
            </div>
          </div>
        </div>



        <div className="col-sm-3 ">
          <div className="input-group">
            <label className="form-label">Unit</label>
            <div className="input-pad">
              <InputField
                type="text"
                name="unit"
                value={formData.unit}
                className="form-control"
                autoComplete="off"
                placeholder="Enter unit"
                onChange={handleChange}
                onBlur={handleFocusOut}
              />
              {errors.unit && (
                <span
                  className="company-required"
                  style={styleError}
                >
                  {errors.unit}
                </span>
              )} 
            </div>
          </div>
        </div>



        <div className="col-12">
          <div className="input-wrape inquiry-ck-editer">
            <label
              className="form-label inquiry-text"
              for="contact-form-message"
            >
              Remarks
            </label>
            <div className="input-pad">
               <CKEditor
                editor={ClassicEditor}
                data={formData.message || ''}
                config={{
                  toolbar: {
                    items: ['bold', 'italic', 'underline', 'fontSize', 'bulletedList'],
                  },
                  fontSize: {
                    options: [10, 12, 14, 'default', 18, 20, 22, 24, 30],
                    supportAllValues: false,
                  },
                  language: 'en',
                  plugins: [
                    Essentials,
                    Bold,
                    Italic,
                    Underline,
                    FontSize,
                    Paragraph,
                    List,
                  ],
                  licenseKey: "GPL",
                  // licenseKey: "",

                }}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setFormData(prev => ({
                    ...prev,
                    message: data,
                  }));
                }}
                onReady={(editor) => {
                  editor.editing.view.change((writer) => {
                    writer.setStyle(
                      "height",
                      "150px",
                      editor.editing.view.document.getRoot()
                    );
                    writer.setStyle(
                      "width",
                      "100",
                      editor.editing.view.document.getRoot()
                    );
                  });
                }}
              />
              {/* {errors.message && (
                <span
                  className="company-required"
                  style={styleError}
                >
                  {errors.message}
                </span>
              )} */}
            </div>
          </div>
        </div>      

        <div className="col-md-12 inquiry-form-btn ">
            <ButtonCancell
              className="inq-form-btn"
              type="button"
              // disabled={isButtonDisabled}
              onClick={handleCancelClick}
            > Cancel
            </ButtonCancell>
          <ButtonAdminpanel type="submit"
            className="inq-form-btn"
            disabled={isButtonDisabled}
            >
             {popupType === "edit" ? "Update" : "Save"}
          </ButtonAdminpanel>


        </div>

      </div>
      </form>
      </MediumPopup>

      {/** Inquiry Detail Pop-up End */}

      <MediumPopup title={`Supplier Inquiry`}
        mediummodalShow={inqModalShow}
        setMediumModalShow={setInqModalShow}>
        
        {inqType === "SUPPLIER" && <SupplierInquiry mediummodalShow={inqModalShow}
          setMediumModalShow={setInqModalShow} pageView="pop_up" fromPage="list" getData={getAllInquiries} limit={limit} current_page={current_page} searchFilterObj={searchFilterObj} />}

      </MediumPopup>

      {/** Delete Inquiry popup */}
      <SmallPopup
        title="Delete Inquiry"
        smallmodalShow={smallmodalShow}
        setSmallModalShow={setSmallModalShow}
        onSubmit={handleConfirmDeleteClick}
        closeButtonLabel="Cancel"
        okButtonLabel="Delete"
      >
        <div className='row my-3'>
          <div className="col-md-12 p-0">Are you sure you want to delete Inquiry?</div>
        </div>

      </SmallPopup>

      {/* <ToastContainer /> */}
    </div>
  );
};

const mapStateToProps = (state) => {
  // console.log('state -->', state);
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAllInquiries: (limit, current_page, filterObj) =>
      dispatch(getAllAdminInquiries(limit, current_page, filterObj)),
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),
    getCountryList: () => dispatch(getCountryList()),
    deleteInquiry: (InqId) => dispatch(deleteInquiry(InqId)),
     getCategories: () => dispatch(getCategories()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SupplierInquiries);
